import {createContext} from 'react';

const ProfilePictureSettings = createContext({pp:"", updateProfilePictureSettings:()=>{}});

export default ProfilePictureSettings;